import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import moment from "moment";
import {Box, Button, Grid, Typography} from "@mui/material";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import AddIcon from "@mui/icons-material/Add";
import CircleIcon from "@mui/icons-material/Circle";
import axiosClient from "./../../../utils/axios-client";
import {NotifyContext} from "../../../contexts/notifyContext";
import PaymentModal from "./paymentModal";
import CancelMembershipModal from "./cancelMembershipModal";
import AlertSuccess from "../../../components/alert/alertSuccess";
import AlertCancel from "../../../components/alert/alertCancel";

import visa from "../../../assets/images/visa.svg";
import masterCard from "../../../assets/images/masterCard.svg";
import thumbGreen from "../../../assets/images/thumbGreen.svg";
import closeOutline from "../../../assets/images/closeOutline.svg";
import checkbox from "../../../assets/images/checkbox.svg";
import payPass from "../../../assets/images/payPass.svg";
import "./billing.css";
import {
  useGetPaymentMethods,
  useGetStripeSubscription,
  useHandleStripeSubscription,
  useStripePaymentMethod,
} from "../../../graphql/graphql/stripe/hooks";
import {useConfirm} from "material-ui-confirm";
import LoadingWall from "../../../components/loadingWall";
const cardImages = {
  visa: visa,
  mastercard: masterCard,
};

const Billing = () => {
  const {toast} = useContext(NotifyContext);
  const [defaultCard, setDefaultCard] = useState(null);
  // const [subscription, setSubscription] = useState([]);
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showWarn, setShowWarn] = useState(false);
  const [defaultCardId, setDefaultCardId] = useState("");
  const {paymentMethods: cards = [], refetch} = useGetPaymentMethods();
  const {subscription, loading} = useGetStripeSubscription();
  const {updateDefaultPaymentMethod, removePaymentMethod} = useStripePaymentMethod();
  const {cancelSubscription, updateSubscriptionWithProrated, undoCancelSubscription} = useHandleStripeSubscription();
  //console.log("🚀 ~ file: billing.jsx:40 ~ Billing ~ subscription", subscription);
  const confirm = useConfirm();

  useEffect(() => setDefaultCard(cards.find((card) => card.default)), [cards]);
  // const getMyCards = async () => {
  //   try {
  //     const {data} = await axiosClient.post("/user/stripe/payment_methods");
  //     if (Array.isArray(data)) {
  //       setCards(data);
  //       setDefaultCard(data.find((card) => card.default));
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const getMySubscription = async () => {
  //   try {
  //     const {data} = await axiosClient.get("/user/stripe/subscription");
  //     setSubscription(data?.subscription);
  //   } catch (error) {
  //     setSubscription();
  //     console.log(error);
  //   }
  // };

  const handleClose = () => {
    setOpen(false);
    setOpenCancel(false);
  };

  // useEffect(() => {
  //   getMyCards();
  //   getMySubscription();
  // }, []);

  const setDefaultSource = async () => {
    if (defaultCardId) {
      await updateDefaultPaymentMethod({variables: {input: {paymentMethodId: defaultCardId}}});
      // try {
      //   await axiosClient.post(`/user/stripe/update`, {
      //     default_source: defaultCardId,
      //   });
      //   refetch();
      //   // await getMyCards();
      // } catch (error) {
      //   toast({message: error.message, type: "error"});
      // }
      setOpen(false);
      setDefaultCardId("");
    }
  };

  const onCancleMember = async (terms) => {
    //console.log("Calling");
    try {
      // await axiosClient.put(`/user/stripe/subscription`, {terms: terms});
      await cancelSubscription();
      // await getMySubscription();
      setShowWarn(true);
    } catch (error) {
      //console.log("error", error);
    }
    setOpenCancel(false);
    setTimeout(() => setShowWarn(false), 5000);
  };

  const getYearDiscountMembership = async () => {
    try {
      await updateSubscriptionWithProrated();
      // await axiosClient.put("/user/stripe/subscriptions", {
      //   price: process.env.REACT_APP_STRIPE_YEAR_PLAN,
      //   coupon: process.env.REACT_APP_SIGNUP_50_COUPON_CODE,
      // });
      // await getMySubscription();
    } catch (error) {
      //console.log("error", error);
    }
    setOpenCancel(false);
  };

  const handleGoBack = () => {
    setOpenCancel("cancel" === false);
    setOpenCancel("invite");
  };

  const handleCancleMember = (modal, terms) => {
    if (subscription?.plan == "year") onCancleMember(terms);
    else setOpenCancel("cancelMember");
  };

  if (loading) {
    return <LoadingWall />;
  }
  return (
    <Box className="billingMain">
      <Grid container>
        <Grid item>
          <Typography variant="h4" className="setting_page_heading">
            Billing
          </Typography>
          <Box className="main">
            {!!showAlert && (
              <AlertSuccess
                title="Successfully updated payment method"
                desc="Thanks for adding payment method. Don't forget to set it as default if you'd like to use it next billing cycle."
                setShowAlert={setShowAlert}
              />
            )}
            {!!showWarn && (
              <AlertCancel
                title="Membership successfully cancelled"
                desc="If this was a mistake, please contact hi@buythedip.com ASAP or undo cancellation by clicking the button below. You will have access until the end of your billing cycle."
                setShowWarn={setShowWarn}
              />
            )}
            {!!defaultCard && (
              <Box pb={3} sx={{borderBottom: "1px solid rgba(255, 255, 255, 0.05)"}}>
                <Typography variant="h6" mb={2}>
                  default payment
                </Typography>
                <Box className="creditCardSect">
                  <Box className="cardHead" display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                    <Typography variant="h5">
                      My <span style={{textTransform: "capitalize"}}>{defaultCard?.card?.funding}</span> Card
                    </Typography>
                    <img src={payPass} alt="pay pass" />
                  </Box>
                  <Box
                    className="numSect"
                    px={2}
                    pb={2}
                    display={"flex"}
                    alignItems={"flex-end"}
                    justifyContent={"space-between"}
                  >
                    <Box>
                      <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                        <Typography variant="h2">{defaultCard?.billing_details?.name}</Typography>
                        <Typography>{`${defaultCard?.card?.exp_month?.toLocaleString("en-US", {
                          minimumIntegerDigits: 2,
                          useGrouping: false,
                        })}/${defaultCard?.card?.exp_year}`}</Typography>
                      </Box>
                      <Typography variant="h3" mt={1}>
                        XXXX XXXX XXXX {defaultCard?.card?.last4}
                      </Typography>
                    </Box>
                    <img src={cardImages[defaultCard?.card?.brand] || visa} alt="master card" />
                  </Box>
                </Box>
              </Box>
            )}
            <Box className="paymentSect" py={3} mb={3}>
              <Typography variant="h5">Payment Methods</Typography>
              <Typography my={2}>
                Add, edit, or delete payment methods (you must have a valid card on file before deleting all other cards). Your card info is NOT stored in our databases whatsoever and cannot be accessed by any of our team members— 
                ALL payments are handled by our payment processor Stripe.
              </Typography>
              {cards.map((card) => (
                <Box
                  key={card.id}
                  className={`methodSect ${card.default && "activeMethodSect"}`}
                  p={2}
                  display={"flex"}
                  alignItems={"flex-start"}
                  justifyContent={"space-between"}
                >
                  <Box display={"flex"} alignItems={"flex-start"}>
                    <img src={cardImages[card.card?.brand]} alt="payment card" className="methodIcon" />
                    <Box>
                      <Typography variant="h3">
                        <span style={{textTransform: "capitalize"}}>{card.card?.brand}</span>{" "}
                        {`ending in ${card.card?.last4}`}
                      </Typography>
                      <Typography>{`Expiry ${
                        card.card?.exp_month < 10 ? `0${card.card?.exp_month}` : card.card?.exp_month
                      }/${card.card?.exp_year}`}</Typography>
                      <Typography variant="h2" mt={1}>
                        <span
                          style={{...(!card.default ? {cursor: "pointer"} : {})}}
                          onClick={() => {
                            !card.default && setOpen("default");
                            setDefaultCardId(card?.id);
                          }}
                        >
                          {card.default ? "Default payment" : "Set as default"}
                        </span>
                        <span className="editCard" onClick={() => setOpen(card.id)}>
                          {"Edit"}
                        </span>

                        <span
                          className={" inline-block mx-3 " + (card.default ? " text-gray-400 " : "cursor-pointer")}
                          onClick={() => {
                            !card.default &&
                              confirm({
                                title: <span className="text-white">Are you sure? </span>,
                                description: <span className="text-white">This action is permanent! </span>,
                              })
                                .then(() => {
                                  removePaymentMethod({variables: {input: {slug: card.id}}});
                                  /* ... */
                                })
                                .catch(() => {
                                  /* ... */
                                });
                          }}
                        >
                          {"Delete"}
                        </span>
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="checkIcon">
                    {card.default ? <img src={checkbox} alt="checkbox" /> : <CircleIcon />}
                  </Box>
                </Box>
              ))}
              <Button onClick={() => setOpen("create")}>
                <AddIcon /> Add new payment method
              </Button>
            </Box>
            <Box
              className="cancleMember"
              border={!subscription || subscription?.cancel_at_period_end ? "1px solid #912018" : "1px solid #ffffff0d"}
              p={2}
              my={3}
            >
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="h5">
                  {!subscription
                    ? "You have no active membership"
                    : subscription?.cancel_at_period_end
                    ? "Membership cancelled."
                    : "Cancel Membership"}
                </Typography>
                {subscription && !subscription?.cancel_at_period_end && (
                  <Box className="cancleImg" onClick={() => setOpenCancel("invite")}>
                    <img src={closeOutline} alt="close" />
                  </Box>
                )}
              </Box>
              <Typography mb={2}>
                {subscription
                  ? `${subscription?.cancel_at_period_end ? "Access until" : "Renews at"} ${moment(
                      +`${subscription?.end_date}000`
                    ).format("MMMM Do, YYYY")}`
                  : "No active subscription"}
              </Typography>
              {!!subscription && (
                <Typography variant="h2" display={"flex"} alignItems={"center"} flexWrap={{xs: "wrap", md: "nowrap"}}>
                  {subscription?.cancel_at_period_end ? (
                    <>
                      Keep my membership active
                      <Link variant="text" onClick={undoCancelSubscription}>
                        Undo membership cancellation
                      </Link>
                    </>
                  ) : (
                    <>
                      <img src={thumbGreen} alt="thumb" />
                      Get a free membership instead
                      <Link to="">
                        Learn More
                        <ArrowCircleRightOutlinedIcon />
                      </Link>
                    </>
                  )}
                </Typography>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
      <PaymentModal
        open={open}
        setOpen={setOpen}
        handleClose={handleClose}
        getMyCards={refetch}
        setDefaultSource={setDefaultSource}
        cards={cards}
        defaultCardId={defaultCardId}
        setShowAlert={setShowAlert}
      />
      <CancelMembershipModal
        openCancel={openCancel}
        setOpenCancel={setOpenCancel}
        handleCancleMember={handleCancleMember}
        handleClose={handleClose}
        onCancleMember={onCancleMember}
        getYearDiscountMembership={getYearDiscountMembership}
        handleGoBack={handleGoBack}
      />
    </Box>
  );
};

export default Billing;
